import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import styled, { css } from 'styled-components'
import {
  backgroundCss,
  borderCss,
  mobileBackgroundCss,
  mobileBorderCss,
} from '../../../../utils/styleUtilsNew'

type ImageBackgroundUiProps = BorderEntityInterface & {
  width?: number | string
  mobileWidth?: number | string
  background?: string
  mobileBackground?: string
}

const ImageBackgroundUi = styled.div<ImageBackgroundUiProps>`
  max-width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  pointer-events: none;
  object-fit: contain; // keep proportions
  width: ${p => (typeof p.width === 'string' ? p.width : `${p.width}px`)};
  ${borderCss}
  ${backgroundCss}
  ${p => p.theme.phone} {
    ${mobileBackgroundCss};
    ${mobileBorderCss}
    ${p =>
      p.mobileWidth &&
      `width: ${
        typeof p.mobileWidth === 'string' ? p.mobileWidth : `${p.mobileWidth}px`
      }`}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBackgroundCss};
      ${mobileBorderCss}
      ${
        p.mobileWidth &&
        `width: ${
          typeof p.mobileWidth === 'string'
            ? p.mobileWidth
            : `${p.mobileWidth}px`
        }`
      }
    `}
`

export default ImageBackgroundUi
